import { Flex, Tooltip, Typography } from "antd"
import { PushRole, useAuth } from "../hooks/useAuth";
import { useQuery } from "@tanstack/react-query";
import { ResponsiveContainer, LineChart, Line, XAxis, YAxis, Legend, Label, CartesianGrid } from "recharts";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { StatisticView } from "../components/StatisticView";
import { isSameMonth } from "../utils/date.utils";

export const Dashboard = (props:{applicationId:string})=> {
    const auth = useAuth();
    const registrationStatsQuery = useQuery({ staleTime: 300000, queryKey: ['application', props.applicationId, 'registrationStats'], queryFn: () => auth.api.getApplicationRegistrationStats(props.applicationId) })

    let statistics = [
        { name: "Total Subscribers", value: registrationStatsQuery.data?.total ?? 0},
        { name: "Active Subscribers", value: registrationStatsQuery.data?.active ?? 0}
    ].filter(x=>x.value > 0);

    let data = registrationStatsQuery.data;
    
    let monthsIndata = 0;
    if(data && data?.cumulativeSummary.length > 1)
    {
        let firstValue = data.cumulativeSummary[0].date.getTime();
        let lastValue = data.cumulativeSummary[1].date.getTime();
        monthsIndata = Math.ceil((lastValue - firstValue) / (1000*60*60*24*30))
    }

 
    let ticks = (registrationStatsQuery.data?.cumulativeSummary ?? []).reduce<number[]>((prev,next)=>{
        let lastEntry:number = prev[prev.length -1 ];
        if(!lastEntry || !isSameMonth(new Date(lastEntry), next.date))
        {
            prev.push(next.date.getTime())
        }
        return prev;
    },[]);
    if(ticks.length = 1) {
        ticks = [(new Date().getTime() - (1000*60*60*24*30)), ...ticks]
    }
    return (
        <Flex vertical gap={10}>
            <Flex justify="space-between"><Typography.Title level={3}>Dashboard</Typography.Title></Flex>
            <Flex vertical={false} gap={10} justify="center">
                {statistics.map(stat=>(<StatisticView key={stat.name} stat={stat}/>))}
            </Flex>
            {registrationStatsQuery.data &&  (registrationStatsQuery.data?.cumulativeSummary.length ?? 0) > 5  && <Flex vertical>
                <Flex justify="center"><Typography.Title level={4}>Subscribers</Typography.Title></Flex>
                    <ResponsiveContainer width={'100%'} height={400} >
                        <LineChart
                            width={700} height={400}
                            data={(registrationStatsQuery.data?.cumulativeSummary ?? []).map(x=>{
                                return {
                                    count: x.count,
                                    date: x.date.getTime()
                                }
                            })}
                            margin={{
                                top: 5,
                                right: 30,
                                left: 20,
                                bottom: 5
                              }}
                        >
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis 
                                scale={"time"}
                                dataKey="date" 
                                tickFormatter={(time:number)=>dayjs(new Date(time)).format("DD MMM YY")}
                                 />
                            <YAxis overflow={10}/>
                            <Tooltip />
                            
                            
                            <Line isAnimationActive={true} type="monotone" dataKey="count" stroke="#395F50" />

 
                        </LineChart>
                    </ResponsiveContainer>
                </Flex>}
        </Flex>
    )
}